import client from "./client";

const getCategories = () => client.get("/categories");
const addCategory = (name, description) => client.post("/categories", { name, description });
const deleteCategory = (category) => client.post("/categories/deleteCategory", { category });
export default {
    getCategories,
    addCategory,
    deleteCategory,
};
